import { readWebSafeAreaInsets, toSafeAreaMetrics } from '@web/libs/safe-area'
import { type PropsWithChildren, useState } from 'react'
import { SafeAreaProvider } from 'react-native-safe-area-context'

export function WebSafeAreaProvider({ children }: PropsWithChildren) {
  const [metrics] = useState(() => toSafeAreaMetrics(readWebSafeAreaInsets()))

  return <SafeAreaProvider initialMetrics={metrics}>{children}</SafeAreaProvider>
}
